import { MDSText } from "@/mds";
import styled from "@emotion/styled";

export const StyledChip = styled.div<{ $inline?: boolean }>`
  display: ${({ $inline }) => ($inline ? "inline-flex" : "flex")};
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["1"]};
  ${({ $inline }) =>
    !$inline &&
    `
    flex: 1 1 auto;
    overflow: hidden;
  `}
`;

export const StyledIconContainer = styled.div<{ $inline?: boolean }>`
  display: ${({ $inline }) => ($inline ? "inline-block" : "block")};
  margin-right: ${({ theme, $inline }) => ($inline ? theme.spacing["1"] : "0px")};
  .mds-icon {
    font-size: 16px;
  }
`;

export const StyledLabelText = styled(MDSText)<{ $inline?: boolean }>`
  display: ${({ $inline }) => ($inline ? "inline" : "block")};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
